import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './Button';
import LanguageSwitcher from './LanguageSwitcher';
import { useTranslation } from 'react-i18next';

export const Navbar: React.FC = () => {
  const { agentData, logout, setGlobalNotification } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    setGlobalNotification({ message: 'Succesvol uitgelogd.', type: 'success' });
    navigate('/login');
  };

  return (
    <nav className="bg-neutral-800 text-white p-4 shadow-md fixed w-full top-0 z-40">
      <div className="container mx-auto flex justify-between items-center px-2 md:px-0">
        {/* Left: Logo + menu items */}
        <div className="flex items-center space-x-6">
          <Link to="/dashboard" title="HomeMe Portaal Dashboard">
            <img src="/logo.png" alt="HomeMe Portaal Logo" className="h-10 w-auto rounded-[8px]" />
          </Link>
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/dashboard" className="hover:text-homeme transition-colors">{t('dashboard')}</Link>
            <Link to="/add-listing" className="hover:text-homeme transition-colors">{t('add_listing')}</Link>
          </div>
        </div>
        {/* Right: Desktop buttons */}
        <div className="hidden md:flex items-center space-x-4">
          <Button onClick={handleLogout} variant="ghost" size="small">
            {t('logout')}
          </Button>
          <LanguageSwitcher />
        </div>
        {/* Hamburger for mobile */}
        <button
          className="md:hidden flex items-center justify-center p-2 rounded hover:bg-neutral-700 focus:outline-none focus:ring-2 focus:ring-homeme"
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Open menu"
        >
          <svg className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        {/* Mobile menu overlay */}
        {menuOpen && (
          <div className="fixed inset-0 z-50 bg-black/40 md:hidden" onClick={() => setMenuOpen(false)}>
            <div
              className="absolute top-0 right-0 w-72 max-w-full h-full bg-white text-neutral-900 shadow-2xl flex flex-col rounded-l-2xl p-0 animate-slide-in"
              onClick={e => e.stopPropagation()}
            >
              <div className="flex justify-end p-4">
                <button
                  className="text-3xl text-neutral-400 hover:text-neutral-700 focus:outline-none"
                  onClick={() => setMenuOpen(false)}
                  aria-label="Sluit menu"
                >
                  &times;
                </button>
              </div>
              <nav className="flex flex-col items-center gap-2 px-6">
                <Link to="/dashboard" className="w-full text-lg font-semibold py-3 rounded hover:bg-neutral-100 text-center" onClick={() => setMenuOpen(false)}>{t('dashboard')}</Link>
                <Link to="/add-listing" className="w-full text-lg font-semibold py-3 rounded hover:bg-neutral-100 text-center" onClick={() => setMenuOpen(false)}>{t('add_listing')}</Link>
              </nav>
              <div className="my-4 border-t border-neutral-200 mx-6" />
              <div className="flex flex-col items-center gap-3 px-6">
                <Button onClick={() => { setMenuOpen(false); handleLogout(); }} variant="ghost" size="large" className="w-full text-center text-homeme font-bold border border-homeme bg-homeme/10 hover:bg-homeme/20">
                  {t('logout')}
                </Button>
                <div className="w-full flex justify-center"><LanguageSwitcher /></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
